import React from "react";
import { useSpring, animated } from "react-spring";
import { useInView } from "react-intersection-observer";
import exp from "../../asset/landing_images/landing-exp.webp";
import { Col, Row } from "antd";

const LandingExpress = () => {
  const isTabletOrMobile = window.innerWidth <= 1024;

  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  // Animation for the text section
  const textAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? "translateY(0)" : "translateY(30px)",
    config: { tension: 60, friction: 30, duration: 1000 },
  });

  // Animation for the image section
  const imageAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? "translateY(0)" : "translateY(30px)",
    config: { tension: 60, friction: 30, duration: 1000 },
  });

  return (
    <div
      id="features"
      ref={ref}
      style={{
        display: "flex",
        flexDirection: isTabletOrMobile ? "column" : "row",
        justifyContent: isTabletOrMobile ? "center" : "space-evenly",
        alignItems: "center",
        textAlign: isTabletOrMobile ? "center" : "left",
        marginTop: "6rem",
        padding: isTabletOrMobile ? "1rem" : "0 8rem",
        // border: '2px solid red'
      }}
    >
      <Row style={{ width:'100%', display:'flex', justifyContent:'center'
      }}>
      <Col md={24} lg={12}>
        {/* Animated text section */}
      <animated.div style={textAnimation}>
        <h1
          style={{
            color: "#30CDD8",
            marginBottom:'2rem',
            textAlign: isTabletOrMobile ? "center" : "left",
            fontSize:isTabletOrMobile ? "2.2rem" :'3.5rem'
          }}
        >
          Freely <br />
          <span style={{ color: "#000", fontWeight: "bold" }}>
            Express Yourself
          </span>
        </h1>
        <p
          style={{
            textAlign: isTabletOrMobile ? "center" : "left",
            marginTop: isTabletOrMobile ? "0" : "-1.3rem",
          }}
        >
          Post text, videos, photos, and even polls <br /> effortlessly <br />
          Tag friends and share your location with <br /> integrated maps <br />
          Add a splash of color with custom background
        </p>
        <a href="https://www.youthplus.ng" style={{textDecoration:'none', }} target="blank">
        <button
          style={{
            color: "#4E99DD",
            border: "2px solid #4E99DD",
            backgroundColor: "#fff",
            borderRadius: "8px",
            padding: isTabletOrMobile ? "15px" : "20px",
            marginTop: isTabletOrMobile ? "1rem" : "0",
          }}
        >
          Learn more
        </button></a>
      </animated.div>
      </Col>
      <Col md={24} lg={12}>
        {/* Animated image section */}
        <animated.div style={imageAnimation}>
          <img
            src={exp}
            style={{
              height: isTabletOrMobile ? "18rem" : "30rem",
              marginTop: isTabletOrMobile ? "1.5rem" : "0",
              width:isTabletOrMobile ? "70%" : "100%"
            }}
            alt="Express Yourself"
          />
        </animated.div>
      </Col>
      </Row>
      

      
    </div>
  );
};

export default LandingExpress;
